import React from 'react';
import ControlGroup from '@amzn/meridian/control-group';
import RadioButton from '@amzn/meridian/radio-button';
import { FormikProps } from 'formik';

interface FormikRadioGroupOption {
  value: string;
  label: string | React.ReactNode;
}

interface FormikRadioGroupProps {
  formik: FormikProps<any>;
  fieldName: string;
  options: (string | FormikRadioGroupOption)[];
  legend?: string;
  disabled?: boolean;
}

const FormikRadioGroup: React.FC<FormikRadioGroupProps> = ({
  formik,
  fieldName,
  options,
  legend,
  disabled = false,
}) => {
  const handleChange = (value: string) => {
    formik.setFieldValue(fieldName, value);
  };

  return (
    <ControlGroup
      legend={legend}
      name={fieldName}
      onChange={handleChange}
      value={formik.values[fieldName]}
      disabled={disabled}
    >
      {options.map((option, index) => {
        const isStringOption = typeof option === 'string';
        const value = isStringOption ? option : option.value;
        const label = isStringOption ? option : option.label;

        return (
          <RadioButton key={index} value={value} disabled={disabled}>
            {label}
          </RadioButton>
        );
      })}
    </ControlGroup>
  );
};

export default FormikRadioGroup;
